import React from 'react';
import { FaMailBulk, FaMapMarkerAlt, FaPhoneVolume } from 'react-icons/fa';

const Contact = () => {
    return (
      <div className=" px-20" id='contact'>
        <div className="text-center">
          <h2 className="text-3xl mb-5">Contact Me</h2>
          <p>
              Get in touch with. and feel free to knock me with your problem.
            </p>
        </div>
        <div className="grid gap-6 mt-8 mb-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
          <div>
            <h2 className=" text-3xl my-6">Contact Information</h2>
            
            <div>
              <div className="card w-96 bg-neutral text-neutral-content mt-5">
                <div className="card-body items-center text-center ">
                  <div className=" flex justify-center items-center">
                    <div className="mr-3 text-4xl">
                      <FaPhoneVolume></FaPhoneVolume>
                    </div>

                    <div>
                      <h2 className="card-title">Contact on Phone</h2>
                      <p>+8801884527975</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card w-96 bg-neutral text-neutral-content mt-5">
                <div className="card-body items-center text-center">
                  <div className=" flex justify-center items-center">
                    <div className="mr-3 text-4xl">
                      <FaMailBulk></FaMailBulk>
                    </div>

                    <div>
                      <h2 className="card-title">Contact on Email</h2>
                      <p>meraz.rahman99@gmail.com</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card w-96 bg-neutral text-neutral-content mt-5">
                <div className=" card-body items-center text-center">
                  <div className=" flex justify-center items-center">
                    <div className="mr-3 text-4xl">
                      <FaMapMarkerAlt></FaMapMarkerAlt>
                    </div>

                    <div>
                      <h2 className="card-title">Contact on Address</h2>
                      <p>Dhaka, Bangladesh</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='my-8'>
            <form action="https://formspree.io/f/xaykralo"
            method="POST">
              <div className="form-control w-full ">
                <label className="label">Name</label>
                <input
                  type="text"
                  name='name'
                  id='username'
                  placeholder="Your name"
                  required
                  autoComplete='off'
                  className="input input-bordered w-full "
                />
              </div>
              <div className="form-control w-full ">
                <label className="label">Email</label>
                <input
                  type="email"
                  name='email'
                  placeholder="Your Email"
                  id='email'
                  required
                  autoComplete='off'
                  className="input input-bordered w-full "
                />
              </div>
              <div className="form-control w-full ">
                <label className="label">Subject</label>
                <input
                  type="text"
                  name='subject'
                  placeholder="Your Subject"
                  required
                  id='subject'
                  autoComplete='off'
                  className="input input-bordered w-full "
                />
              </div>
              <div className="form-control w-full ">
                <label className="label">Message</label>
                <textarea
                  className="textarea textarea-bordered h-24"
                  placeholder="Write your message"
                  name='textarea'
                  id='textarea'
                  required
                ></textarea>
              </div>
              <button className="btn mt-4">SEND MAIL</button>
            </form>
            
          </div>
        </div>
      </div>
    );
};

export default Contact;